import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
// import type { Map } from 'immutable';

const styles = {
  row: {
    backgroundColor: '#334058',
    color: 'white',
    textAlign: 'center'
  }
};
const HeaderRow = props => {
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(props.params.className, " ").concat(props.classes.row),
    role: "row",
    style: {
      width: props.width
    },
    "data-testid": "headerRow"
  }, props.params.columns);
};
export default withStyles(styles)(HeaderRow);